import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeCs from '@angular/common/locales/cs';
import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { NgxSpinnerModule } from 'ngx-spinner';

import { ApiModule } from './api';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ApiInterceptor } from './core/guards/api.interceptor';
import { InitService } from './core/services/init.service';
import { SharedModule } from './shared/shared.module';
import { TranslocoRootModule } from './transloco-root.module';
import { environment } from '../environments/environment';
import {ToastrModule} from "ngx-toastr";
import { RecommendationsModule } from './modules/recommendations/recommendations.module';

registerLocaleData(localeCs, 'cs');

export const initApplication = (initService: InitService) => () => initService.initApplication();

@NgModule({
  declarations: [AppComponent],
  imports: [
    ApiModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    TranslocoRootModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    NgxSpinnerModule,
    HttpClientModule,
    FormsModule,
    ToastrModule.forRoot(),
    NgxGoogleAnalyticsModule.forRoot(environment.ga_measurement_id),
    NgxGoogleAnalyticsRouterModule,
    RecommendationsModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    { provide: LOCALE_ID, useValue: 'cs' },
    provideAppInitializer(() => {
        inject(Sentry.TraceService);
        const initializerFn = (initApplication)(inject(InitService));
        return initializerFn();
      }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
